import styled from 'styled-components';
import {Panel} from '../../atoms/Panel/index';
import AnswerForm from '../../molecules/AnswerForm/index';
import Divider from '../../atoms/Divider';
import TextButton from '../../atoms/TextButton';
import OutlinedButton from '../../atoms/OutlinedButton';
import {SearchIcon} from '../../atoms/Icons';
import CountdownTimer from '../../molecules/CountdownTimer';
import FloatingActionButton from '../../atoms/FloatingActionButton';
import {
	DividerColor, 
	OnPrimaryVariant, 
	DefaultPrimaryColor, 
	LightPrimaryColor, 
	SurfaceColor, 
	Grey500,
	Grey600
} from '../../Colors';

export default {
	Wrapper : styled.div`
		position : relative;
		display : flex;
		flex-direction : column;
		height : 100%;
	`,
	h4 : styled.h4`
		color : ${OnPrimaryVariant};
	`,
	QuizHeader : styled.h3`
		padding-left : 2rem;
		color : ${Grey600};
    `,
	ContentWrapper : styled.div`
        padding : 1rem;
    `,
	QuestionWrapper : styled(Panel)`
		background-color : ${SurfaceColor};
		white-space:pre-wrap;
	`,
	AnswerForm : styled(AnswerForm)`
		background-color : ${SurfaceColor};
	`,
	QuizFooter : styled.div`
        display : flex;
		justify-content : center;
		padding : 10px;
		margin-bottom : 1rem;
		& > #space {
			margin-right : 1rem;
			margin-left : 1rem;
		}
		`,
	FloatingActionButton : styled(FloatingActionButton)`
		font-size : 2rem;
		padding : 1.5rem;
		border-radius : 50%;
	`,
	Content : styled.div`
        flex : 1;
        padding-left : 1rem;
        padding-right : 1rem;
	`,
	Divider : styled(Divider).attrs({
		borderStyle : 'dotted',
		color : DividerColor,
		height : '1px',
	})`
		margin-bottom : 0;
	`,
	CountdownTimer : styled(CountdownTimer)`
	`,
	Sample : {
		Wrapper : styled.div`
			position : relative;
			display : flex;
			flex-direction : column;
			padding : 1rem 3rem 1rem 3rem;
			overflow: auto;
		`,
		QuizHeader : styled.div`
			display : flex;
			padding : 10px;
			font-size:2rem;
			background-color : ${LightPrimaryColor};
			color : ${DefaultPrimaryColor};
		`,
		NextPrevWrapper : styled.div`
			margin-top:auto;
			position : relative;
			text-align : right;
		`,
		NextButton : styled(OutlinedButton)`
		`,
		PrevButton : styled(OutlinedButton)`
			margin-right : 1rem;
		`,
		AnswerText : styled.span`
			color : red;
			font-weight : bold;
		`,
		AnswerButtonWrapper : styled.div`
			text-align : right;
		`,
		TextButton,
		SearchIcon : styled(SearchIcon)`
			margin-right : 1rem;
		`,
		NoSampleLogo : styled.div`
			padding : 1rem;
			font-size : 2rem;
			color : ${Grey500};
			text-align : center;
		`,
	}
};